import * as React from 'react';

const BgBubblesPattern = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 361 201"
    fill="none">
    <mask
      id="a"
      width={361}
      height={201}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path
        fill="#D9D9D9"
        d="M354.16.8h-348a6 6 0 0 0-6 6v188.001a6 6 0 0 0 6 6h348a6 6 0 0 0 6-6v-188a6 6 0 0 0-6-6Z"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#fff"
        fillOpacity={0.55}
        stroke="#fff"
        strokeWidth={0.55}
        d="M271.783 119.772a6.6 6.6 0 1 0 0-13.2 6.6 6.6 0 0 0 0 13.2ZM39.408 95.022a7.975 7.975 0 1 0 0-15.95 7.975 7.975 0 0 0 0 15.95Z"
      />
      <path
        stroke="#fff"
        strokeWidth={0.55}
        d="M163.158 106.03a7.976 7.976 0 1 0-.001-15.951 7.976 7.976 0 0 0 .001 15.951Z"
      />
      <path
        stroke="#fff"
        strokeOpacity={0.22}
        strokeWidth={0.55}
        d="M300.658 100.522a7.975 7.975 0 1 0 0-15.95 7.975 7.975 0 0 0 0 15.95Z"
      />
      <path
        fill="#fff"
        fillOpacity={0.33}
        stroke="#fff"
        strokeWidth={0.55}
        d="M115.032 100.522a3.85 3.85 0 1 0 0-7.7 3.85 3.85 0 0 0 0 7.7Z"
      />
      <path
        fill="#fff"
        fillOpacity={0.2}
        d="M134.284 76.05a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75ZM315.783 120.055a1.376 1.376 0 1 0-.001-2.751 1.376 1.376 0 0 0 .001 2.751ZM260.783 81.547a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.55}
        d="M83.408 86.78a2.475 2.475 0 1 0 0-4.95 2.475 2.475 0 0 0 0 4.95Z"
      />
      <path
        fill="#fff"
        fillOpacity={0.2}
        d="M25.66 120.051a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.55}
        d="M143.908 128.03a2.475 2.475 0 1 0 0-4.95 2.475 2.475 0 0 0 0 4.95Z"
      />
      <path
        fill="#fff"
        fillOpacity={0.33}
        stroke="#fff"
        strokeWidth={0.55}
        d="M185.158 84.022a2.475 2.475 0 1 0 0-4.95 2.475 2.475 0 0 0 0 4.95Z"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.55}
        d="M330.908 92.276a2.475 2.475 0 1 0 0-4.95 2.475 2.475 0 0 0 0 4.95Z"
      />
      <path
        fill="#fff"
        fillOpacity={0.12}
        stroke="#fff"
        strokeWidth={0.55}
        d="M197.532 125.28a3.85 3.85 0 1 0 0-7.7 3.85 3.85 0 0 0 0 7.7Z"
      />
      <path
        fill="#fff"
        fillOpacity={0.22}
        stroke="#fff"
        strokeWidth={0.55}
        d="M354.282 117.022a9.35 9.35 0 0 0 9.35-9.35 9.35 9.35 0 0 0-9.35-9.35 9.35 9.35 0 0 0-9.35 9.35 9.35 9.35 0 0 0 9.35 9.35Z"
      />
    </g>
  </svg>
);

export default BgBubblesPattern;
